import { render, staticRenderFns } from "./BigData.vue?vue&type=template&id=248b9c6e&scoped=true&"
import script from "./BigData.vue?vue&type=script&lang=js&"
export * from "./BigData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248b9c6e",
  null
  
)

export default component.exports